import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { BANNER_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { BANNER_NAME } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { INVITE_FRIENDS } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_PROFILE_INVITE } from 'apps/auth/constants/UrlConstants';
import { fetchData } from 'apps/auth/helpers/api';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { getAmountPerReferralUser, getMaxPossibleAmount } from 'apps/auth/services/bonusService';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import styles from './Banners.module.css';

const MgmCampaignBanner = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { mgmPromoBannerTitle, mgmPromoBannerText } = usePageMessages();
    const { bonusReferralInfo } = useExtra();

    const onClose = (e) => {
        e.stopPropagation();
        props.updateExtraByName('showMgmPromoBannerEnabled', false);
        fetchData('/auth/profile/bonus/hide/banner');
    };

    return (
        <div
            className={styles.bannerContainer}
            onClick={(e) => {
                e.preventDefault();
                amplitude.getInstance().logEvent(BANNER_CLICKED, { [BANNER_NAME]: INVITE_FRIENDS });
                props.toggleSpinner(true);
                window.location.href = AUTH_PROFILE_INVITE;
            }}
        >
            <span className={styles.bannerCloseButton}>
                <DiskButton size="small" iconName="cross" iconColor="white_base" type="button" variant="glass" onClick={onClose} />
            </span>
            <div>
                <Text variant="div" color="white_base" indent="8px" size="main">
                    {resolveArguments(mgmPromoBannerTitle, [
                        getMaxPossibleAmount(lang, country, bonusReferralInfo) + ' ' + bonusReferralInfo?.referralInfo?.bonus?.ccyIso,
                    ])}
                </Text>
                <div className={styles.bannerSubtitle}>
                    <Row indent="16px">
                        {MarkdownService.splitByParagraph(
                            mgmPromoBannerText || '',
                            [getAmountPerReferralUser(lang, country, bonusReferralInfo) + ' ' + bonusReferralInfo?.referralInfo?.bonus?.ccyIso],
                            { color: 'white_base', size: 'secondary' },
                        )}
                    </Row>
                </div>
            </div>
        </div>
    );
};
export default connect(null, { toggleModal, toggleSpinner })(MgmCampaignBanner);
